// @flow
import * as React from 'react';
import classnames from 'classnames';

type UgcLinkContextShape = Ugc => string;

// $FlowFixMe
const UgcLinkContext = React.createContext();

// do not render anything if linker is not a function
function Consumer(props: { children: UgcLinkContextShape => React.Node }) {
  return (
    <UgcLinkContext.Consumer {...props}>
      {val => {
        return typeof val === 'function' ? props.children(val) : null;
      }}
    </UgcLinkContext.Consumer>
  );
}

export default { Provider: UgcLinkContext.Provider, Consumer };

type UgcLinkButtonProps = {
  href: string,
  label: string,
  darkerButton?: boolean,
};

export const UgcLinkButton = (props: UgcLinkButtonProps) => {
  const defaultStyles =
    ' tc db w-100 ba b--black-025 white no-underline br1 brandon button-reset input-reset f5 lh-title ph3 pv2 dim pointer mt2';

  return (
    <a
      href={props.href}
      target="_blank"
      className={classnames(defaultStyles, {
        'bg-black': props.darkerButton === true,
        'secondary-btn-gray': props.darkerButton !== true,
      })}
      rel="noopener noreferrer"
      data-test="ugc-link-button"
    >
      {props.label}
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/containers/UgcLinkContext.js